import { CREATE_MESSAGE } from "./actionTypes";

export const createMessage = (message) => ({
  type: CREATE_MESSAGE,
  payload: message,
});
